<template>
  <div class="depart_container">
        <a-form  class="gufiiguy">
            <a-form-model :model="allform" ref="allformRef" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
             <a-row>
                  <a-col :span="2">
                      <span class="replace" v-if="replaceTypes == 1">替换为：</span>
                      <span class="replace" v-else>移交至：</span>
                  </a-col>
                 <a-col :span="10">
                     
						<a-form-model-item label="部门" prop="department" :rules="{
						  required: true,
						  message: '请输入部门',
						  trigger: 'change',
						}">
						<a-tree-select allowClear :treeData="departList" placeholder="请选择"  v-model="allform.department"
							 @change="selectDepartment" >
						</a-tree-select>
						</a-form-model-item>
		
					</a-col>
					<a-col :span="10">
						<a-form-model-item label="姓名" prop="name" :rules="{
						  required: true,
						  message: '请输入姓名',
						  trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择" v-model="allform.name" @change="getUserInforEvent" show-search :filter-option="filterOption">
						        <a-select-option :value="item.userId" v-for="(item, index) in users" :key="index">
							       {{ item.userName }}
						        </a-select-option>
					        </a-select>
						</a-form-model-item>
					</a-col>
             </a-row>
             </a-form-model >
        </a-form>
  </div>
</template>

<script>
import { getUserList } from '@/api/system'
import { tree_all } from '@/api/purchase'
export default {
    props: ['replaceTypes',
      'allform',
      'department',
      'name',
      'users'
    ],
    data() {
        return {
            // allform: [],
            departList: {},
            users: {},
            newCharger: ''
        }
    },
    created() {
        tree_all().then(res => {
            console.log(res, 'res')
            let companyList = res.data[0]
            console.log(companyList, 'companyList')
            let companyId = this.$store.state.user.info.companyId
            // if(!companyList) {
                 companyList.forEach(item => {
                if( item.deptId == companyId) {
                  this.departList = item.children
                   this.departList.forEach(item3 => {
                item.value = item3.deptId
                item.title = item3.title
             if(item.children) {
                item3.children.forEach( item1 => {
                item1.value = item1.deptId
                item1.title = item1.title
                 item1.children.forEach( item2 => {
                item2.value = item2.deptId
                item2.title = item2.title
             })
             })
          }
          return this.departList

                   })

                }
                
            });
        
            })
    },
    watch: {
        // this.allform.department = this.department,
        // this.allform.name = this.name

    },
    methods: {
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
        
        selectDepartment(e) {
            console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
            this.allform.name = ''
            // this.allform.department = ''
            getUserList({
					deptId: e
				}).then(res => {
					if(res.code == 200){
                     const  UserList =  []
                      res.rows.forEach(item => {
                            if(item.status == 0 && item.userId != this.$route.query.id) {
                                UserList.push(item)
                            }
                        })
                        this.users = UserList
						
						console.log(this.users, 'this.users===================================')
					
					} else {
						this.$message.error(res.msg)
					}
				console.log(res,'res======================================')

				})
                this.$forceUpdate()
        },
        getUserInforEvent(e) {
            // this.$refs.allformRef.validate((valid) => {
			// 		if (valid) {
                        
            //         }
            //         })
            console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeee')
            console.log( this.users, '1111111111111111111111=========================')
            // this.newCharger = this.allform.name
            console.log( this.allform.name, 'this.allform.name=========================')
            this.users.forEach(item => {
                if(item.userId == e) {
                     
                   this.newCharger = item.userName
                   this.allform.name = item.userName
            //         console.log(this.newCharger, 'this.newCharger=========================')

                     this.$emit("getCharger", {
                         newCharger: this.newCharger,
                         users: this.users})

                }
            })
             this.$forceUpdate()
        },
    }

}
</script>

<style>
/* .gufiiguy {
    margin: 10px;
    padding: 10px;
} */
.replace {
    text-align: center;
    line-height: 40px;
    font-size: 14px;
}
.baseInfo {
    font-size: 20px;
    margin: 20px;
}
</style>